import * as React from "react";
import * as ReactDOM from "react-dom";
import { Button } from "antd";
import { GuideIndicator } from "./guideIndicator";
import { guidePopupStyle, highlightTextStyle, guideHeaderStyle, guideProgressStyle, guideSkipStyle } from "./styles";
import { GuideProps } from "./guides";

export const Context: React.FC<GuideProps> = ({ onDone, onSkip, currentStep, totalSteps }) => {
  const [step, setStep] = React.useState(0);
  const [position, setPosition] = React.useState({ top: 60, left: 200 });

  React.useEffect(() => {
    const updatePosition = () => {
      const element = document.querySelector('[data-guide="context-widget"]');
      if (element) {
        const rect = element.getBoundingClientRect();
        setPosition({ top: rect.bottom + 10, left: rect.left });
      }
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  React.useEffect(() => {
    if (step >= 1) {
      onDone();
    }
  }, [step]);

  if (step === 0) {
    return (
      <>
        <GuideIndicator selector='[data-guide="context-widget"]' />
        {ReactDOM.createPortal(
          <div style={{ position: "fixed", top: position.top, left: position.left, zIndex: 10001 }}>
            <div style={guidePopupStyle}>
              <div style={guideHeaderStyle}>
                <div className="font-semibold">
                  <span className="mr-4 text-sm uppercase">GUIDE</span>Context Selection
                </div>
                <div style={guideProgressStyle}>{currentStep}/{totalSteps}</div>
              </div>
              <div className="text-sm mb-4">
                The <span style={highlightTextStyle}>highlighted selector</span> controls your current
                organization and GVC context.
              </div>
              <div className="text-sm mb-4">
                <strong>GVC is now optional.</strong> When no GVC is selected, you can view resources from all GVCs at
                once.
              </div>
              <div className="text-sm mb-4">Select an org (required) and optionally a GVC to filter your view.</div>
              <div className="w-full flex justify-between items-center mt-4">
                <span style={guideSkipStyle} onClick={onSkip}>Skip all guides</span>
                <Button type={`primary`} onClick={() => setStep(1)}>
                  Got it
                </Button>
              </div>
            </div>
          </div>,
          document.getElementById("guide")!,
        )}
      </>
    );
  }

  return null;
};
